import { Phone } from "lucide-react";
import type { Call } from "@/lib/api/calls";
import { formatDate, formatDuration } from "@/lib/utils";
import { CallRecordingControls } from "@/components/shared/call-recording-controls";

interface ContextCallLogCardProps {
  call: Call;
}

export function ContextCallLogCard({ call }: ContextCallLogCardProps) {
  if (call.status === "scheduled") return null;

  return (
    <div className="flex flex-col gap-2 border-b border-surfaces-divider py-4">
      <div className="flex gap-3">
        <span className="flex size-[22px] shrink-0 items-center justify-center rounded-xl bg-surfaces-z3">
          <Phone className="size-3 text-icon-primary" />
        </span>
        <div className="flex min-w-0 flex-1 flex-col gap-1 pt-0.5">
          <div className="flex items-center justify-between gap-2">
            <span className="font-body text-body-4 text-text-tertiary">Call</span>
            <span className="font-body text-body-4 text-text-tertiary">
              {formatDate(call.created_at)}
            </span>
          </div>
          <p className="font-body text-body-2 text-text-primary">
            Call from {call.fromUser?.name}
          </p>
          <p className="font-body text-body-3 text-text-secondary">
            Duration: {formatDuration(call.duration)}
          </p>
          <CallRecordingControls call={call} />
        </div>
      </div>
    </div>
  );
}
